var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple-music"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Vector",
    cx: 7.99967,
    cy: 8.00741,
    rx: 6.38053,
    ry: 6.38827,
    fill: "url(#paint0_linear_1489_2520)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57757 4.25531L10.7814 3.4198C10.973 3.38173 11.1515 3.52829 11.1515 3.72359V10.1647C11.1515 10.713 10.7681 11.1867 10.2318 11.3008L9.86037 11.3798C9.21338 11.5175 8.60398 11.0241 8.60398 10.3626C8.60398 9.89666 8.91805 9.48925 9.36866 9.37067L10.4213 9.09367C10.5641 9.05607 10.6637 8.9269 10.6637 8.77916V5.78864C10.6637 5.65115 10.5374 5.54838 10.4028 5.57636L6.89963 6.30446C6.79186 6.32686 6.7146 6.42183 6.7146 6.5319V10.9978C6.7146 11.5976 6.29494 12.1156 5.7082 12.24L5.45353 12.294C4.78689 12.4355 4.15929 11.927 4.15929 11.2456C4.15929 10.8113 4.4516 10.4313 4.87139 10.32L5.97319 10.0279C6.10898 9.99189 6.20354 9.86899 6.20354 9.7285V4.711C6.20354 4.48932 6.36015 4.29852 6.57757 4.25531Z",
    fill: "url(#paint1_radial_1489_2520)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM14.3805 8.00774C14.3805 11.5359 11.5239 14.396 8 14.396C4.47613 14.396 1.61947 11.5359 1.61947 8.00774C1.61947 4.4796 4.47613 1.61947 8 1.61947C11.5239 1.61947 14.3805 4.4796 14.3805 8.00774Z",
    fill: "url(#paint2_radial_1489_2520)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1489_2520",
    x1: 7.99967,
    y1: 1.61914,
    x2: 7.99967,
    y2: 14.3957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE2E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1489_2520",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.15929 13.8695) rotate(-55.1325) scale(14.0055 10.9984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A66FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.440198,
    stopColor: "#52A2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#FC5D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85E7B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1489_2520",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.15929 13.8695) rotate(-55.1325) scale(14.0055 10.9984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A66FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.440198,
    stopColor: "#52A2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#FC5D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85E7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/apple-music.08a2c6cb21ea2e20527dabffb2f896e0.svg";
export { ForwardRef as ReactComponent };